<template>
	<div id="onboardingOptions" class="container-fluid mt-2">
		<Breadcrumb :back="'/kpi'" />
		<div class="row my-5">
			<div class="col-md-12">
				<iframe
					class="clickup-embed"
					src="https://sharing.clickup.com/9008171822/b/h/4-90080335085-2/04f4270f129ca74"
					onwheel=""
					width="100%"
					height="700px"
					style="background: transparent; border: 1px solid #ccc;"
				></iframe>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import restApi from '../../api/index'
import Breadcrumb from '../../components/onboarding/breadcrumb/Breadcrumb.vue'

export default {
	name: 'KpiProjects',
	data() {
		return {
			loading: false,
		}
	},
	components: { Breadcrumb },
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']),
	},
	mounted() {},
	created() {},
	methods: {
		// Programming
		getOnboartingTypes() {
			restApi
				.get('/onboarding-type')
				.then(({ data }) => {
					this.onboardingTypes = data
				})
				.catch(error => {
					console.log(error)
				})
		},
	},
	watch: {},
}
</script>
